var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { connect } from '@/overmind';
import Pagination from '@/components/Pagination.vue';
import CreditsHistoryRow from '@/modules/admin/components/AccountManagementModal/AccountManagementeCreditsConsumptionTab/CreditsHistoryRow.vue';
import CreditsHistoryEmpty from '@/modules/admin/components/AccountManagementModal/AccountManagementeCreditsConsumptionTab/CreditsHistoryEmpty.vue';
import CreditsHistorySkeleton from '@/modules/admin/components/AccountManagementModal/AccountManagementeCreditsConsumptionTab/CreditsHistorySkeleton.vue';
import { groupBy } from 'lodash';
import { json } from 'overmind';
let CreditsHistoryContainer = class CreditsHistoryContainer extends Vue {
    constructor() {
        super(...arguments);
        this.historyGrouped = json(groupBy(this.consumptions, 'period'));
    }
    pageChange(page) {
        this.$emit('pageChange', page);
    }
    onChangeCreditsHistory(newHistory, _oldHistory) {
        this.historyGrouped = json(groupBy(newHistory, 'period'));
    }
    showDetails(payload) {
        this.$emit('showDetails', payload);
    }
};
__decorate([
    Prop({ default: [] })
], CreditsHistoryContainer.prototype, "consumptions", void 0);
__decorate([
    Prop({ default: true })
], CreditsHistoryContainer.prototype, "loading", void 0);
__decorate([
    Prop({ default: 1 })
], CreditsHistoryContainer.prototype, "currentPage", void 0);
__decorate([
    Prop({ default: 1 })
], CreditsHistoryContainer.prototype, "totalPages", void 0);
__decorate([
    Prop({ default: 'month' })
], CreditsHistoryContainer.prototype, "groupBy", void 0);
__decorate([
    Watch('consumptions')
], CreditsHistoryContainer.prototype, "onChangeCreditsHistory", null);
CreditsHistoryContainer = __decorate([
    Component(connect(({ actions: { admin: actions } }) => ({
        actions: actions,
    }), {
        components: {
            Pagination,
            CreditsHistoryRow,
            CreditsHistoryEmpty,
            CreditsHistorySkeleton,
        },
    }))
], CreditsHistoryContainer);
export default CreditsHistoryContainer;
